import mixpanel from "mixpanel-browser";
import { setCookie, getCookie, getRootDomain } from "../../utils/index";

const CLIENT_ID_KEY = "ALAYA_CLIENT_ID";

export const getEventBaseParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    site_url: location.href,
    site_host: location.hostname,
    site_path: location.pathname,
    utm_source:
      params.get("utm_source") || getCookie("utm_source") || undefined,
    utm_medium:
      params.get("utm_medium") || getCookie("utm_medium") || undefined,
    utm_campaign:
      params.get("utm_campaign") || getCookie("utm_campaign") || undefined,
    utm_term: params.get("utm_term") || getCookie("utm_term"),
    utm_content:
      params.get("utm_content") || getCookie("utm_content") || undefined,
  };
};

function getClientId() {
  let clientId = getCookie(CLIENT_ID_KEY);

  if (!clientId) {
    clientId = `cid_${crypto.randomUUID()}`;
    setCookie(CLIENT_ID_KEY, clientId, 3650, `.${getRootDomain()}`);
  }

  return clientId;
}
// mixpanel.init(
//   location.host.includes("alayanew.com")
//     ? "d65fe436fe059d1d664be0bf90f344e0" // 线上
//     : "a096b0c744e7a0b0cf820afda33fb9df", // 测试环境
//   {
//     debug: false,
//     autocapture: {
//       pageview: "full-url",
//       click: true,
//       input: true,
//       rage_click: true,
//       dead_click: true,
//       scroll: true,
//       submit: true,
//       capture_text_content: false,
//     },
//     track_pageview: true,
//     persistence: "localStorage",
//     record_heatmap_data: true,
//     ignore_dnt: true,
//   }
// );
// mixpanel.identify(getClientId());
// mixpanel.stop_session_recording();

export const initMixPanel = () => {
  mixpanel.init(
    location.host.includes("alayanew.com")
      ? "fb6b646334dec494d06befc6e2b0e82f" // 线上
      : "09c25e4bf125d64a153c84a8f876b9e1", // 测试环境
    {
      debug: false,
      autocapture: {
        pageview: "full-url",
        click: false,
        input: true,
        rage_click: false,
        dead_click: false,
        scroll: false,
        submit: false,
        capture_text_content: false,
      },
      track_pageview: true,
      persistence: "localStorage",
      record_heatmap_data: true,
      ignore_dnt: true,
    }
  );
  mixpanel.identify(getClientId());
  mixpanel.stop_session_recording();
};

export default () => {
  const trackEvent = (eventName, attributes) => {
    const params = new URLSearchParams(window.location.search);

    mixpanel.track(eventName, {
      ...attributes,
      ...getEventBaseParams(),
    });
  };

  return { trackEvent };
};
